var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"contract",staticClass:"w-100",attrs:{"id":"invitation","contentEditable":"false"},domProps:{"innerHTML":_vm._s(_vm.invitation)}})
}
var staticRenderFns = []

export { render, staticRenderFns }